export const STATUS = {
    success: 200,
  }